import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { ISearchResultsModel } from "../../services/object-search-data-service/Models";
import ObjectSearchDataService from "../../services/object-search-data-service/ObjectSearchDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseSearchResultsQueryParams = {
    groupID: number,
    searchText: string;
} & BaseUseQueryParameters<ISearchResultsModel | undefined>;

export function useSearchResults({
    groupID,
    searchText,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseSearchResultsQueryParams) {
    return useQuery<ISearchResultsModel | undefined, RestError>(
        keys.list(groupID, searchText),
        ({ signal }) => {
            return searchText?.length > 0
                ? ObjectSearchDataService.getObjectSearchData(groupID, searchText, signal)
                : Promise.resolve(undefined);
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false
        }
    );
}